import type { Activity, Asset, CommissionSchedule, Payment, Schedule, SystemUser, Transaction } from '../types';

export const mockPayments: Payment[] = [
  {
    id: 'PMT-5566',
    clientId: 'client-1',
    clientName: 'John Smith',
    policyId: 'PER-P0153674',
    datetime: '2024-10-20T10:22:00Z',
    method: 'credit-card',
    cardLast4: '4242',
    amount: 150.00,
    status: 'success',
    appliedTo: 'INV-001234',
    allocations: [{ invoiceId: 'INV-001234', amount: 150.00 }],
  },
  {
    id: 'PMT-5567',
    clientId: 'client-2',
    clientName: 'Sarah Johnson',
    policyId: 'PER-P0155743',
    datetime: '2024-10-26T14:15:00Z',
    method: 'credit-card',
    cardLast4: '8888',
    amount: 890.00,
    status: 'success',
    appliedTo: 'INV-001235',
    allocations: [{ invoiceId: 'INV-001235', amount: 890.00 }],
  },
  {
    id: 'PMT-5568',
    clientId: 'client-5',
    clientName: 'Lisa Chen',
    policyId: 'PER-P0156102',
    datetime: '2024-10-18T09:30:00Z',
    method: 'direct-debit',
    ddReference: 'DD-2024-1018-001',
    amount: 200.00,
    status: 'success',
    appliedTo: 'INV-001237',
    allocations: [{ invoiceId: 'INV-001237', amount: 200.00 }],
  },
  {
    id: 'PMT-5569',
    clientId: 'client-4',
    clientName: 'ABC Enterprises Ltd',
    policyId: 'PER-P0152990',
    datetime: '2024-10-30T08:00:00Z',
    method: 'direct-debit',
    ddReference: 'DD-2024-1030-001',
    amount: 2800.00,
    status: 'failed',
    appliedTo: 'INV-001238',
    failureReason: 'Insufficient funds',
  },
  {
    id: 'PMT-5570',
    clientId: 'client-1',
    clientName: 'John Smith',
    policyId: 'PER-P0153674',
    datetime: '2024-09-16T11:45:00Z',
    method: 'direct-debit',
    ddReference: 'DD-2024-0916-001',
    amount: 250.00,
    status: 'success',
    appliedTo: 'INV-001239',
    allocations: [{ invoiceId: 'INV-001239', amount: 250.00 }],
  },
];

export const mockTransactions: Transaction[] = [
  {
    id: 'TXN-001',
    clientId: '4772',
    clientName: 'A 2 Z Wholesale Ltd',
    branch: 'Blanket',
    authRepAndBroker: 'Bryn Morgans (20%)',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: 'Vero',
    transactionId: '41977',
    transactionType: 'INV',
    transactionDate: '2025-08-28',
    particulars: 'Business Pack Insurance Cover:HOCBP5677596',
    dateReceivedFromInsurer: '',
    clientBalance: -5406.95,
    balance: -5145.44,
    policyId: 'HOCBP5677596',
    isAllocated: true,
    status: 'allocated',
  },
  {
    id: 'TXN-002',
    clientId: '4772',
    clientName: 'A 2 Z Wholesale Ltd',
    branch: 'Blanket',
    authRepAndBroker: 'Bryn Morgans (20%)',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: '',
    transactionId: '43549',
    transactionType: 'CSH',
    transactionDate: '2025-09-22',
    particulars: 'EFT',
    dateReceivedFromInsurer: '',
    clientBalance: -5406.95,
    balance: -261.51,
    isAllocated: true,
    status: 'allocated',
  },
  {
    id: 'TXN-003',
    clientId: '3741',
    clientName: 'Adrenalin Beach Park Limited',
    branch: 'Blanket',
    authRepAndBroker: 'Shahram Shoar (20%)',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: 'NZI',
    transactionId: '46586',
    transactionType: 'INV',
    transactionDate: '2025-10-31',
    particulars: 'Commercial Motor Insurance Cover:P000778774SVU',
    dateReceivedFromInsurer: '',
    clientBalance: 0.00,
    balance: -2139.82,
    policyId: 'P000778774SVU',
    isAllocated: true,
    status: 'allocated',
  },
  {
    id: 'TXN-004',
    clientId: '3879',
    clientName: 'AKS Trading Ltd',
    branch: 'Blanket',
    authRepAndBroker: '',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: 'Ando',
    transactionId: '46444',
    transactionType: 'INV',
    transactionDate: '2025-10-30',
    particulars: 'Business Pack Insurance Cover:LSF252932',
    dateReceivedFromInsurer: '',
    clientBalance: -0.24,
    balance: -0.24,
    policyId: 'LSF252932',
    isAllocated: true,
    status: 'allocated',
  },
  {
    id: 'TXN-005',
    clientId: '4137',
    clientName: 'Chintanbhai Patel & Jatan patel',
    branch: 'Blanket',
    authRepAndBroker: 'Nitesh Khanna',
    salesTeam: 'Nitesh Khanna',
    serviceTeam: '',
    insurer: '',
    transactionId: '36532',
    transactionType: 'CSH',
    transactionDate: '2025-05-31',
    particulars: 'EFT',
    dateReceivedFromInsurer: '',
    clientBalance: -23.78,
    balance: -23.78,
    isAllocated: false,
    status: 'unallocated',
  },
  {
    id: 'TXN-006',
    clientId: '6474',
    clientName: 'Conor McIntosh',
    branch: 'Blanket',
    authRepAndBroker: 'Regan Thomas',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: '',
    transactionId: '47076',
    transactionType: 'CSH',
    transactionDate: '2025-11-05',
    particulars: 'EFT',
    dateReceivedFromInsurer: '',
    clientBalance: 1111.72,
    balance: -164.78,
    isAllocated: false,
    status: 'unallocated',
  },
  {
    id: 'TXN-007',
    clientId: '1004',
    clientName: 'Garry Garoni',
    branch: 'Blanket',
    authRepAndBroker: '',
    salesTeam: 'Jay Areora',
    serviceTeam: '',
    insurer: '',
    transactionId: '24147',
    transactionType: 'CSH',
    transactionDate: '2024-09-30',
    particulars: 'EFT',
    dateReceivedFromInsurer: '',
    clientBalance: -108.52,
    balance: -108.52,
    isAllocated: false,
    status: 'unallocated',
  },
  {
    id: 'TXN-008',
    clientId: '6455',
    clientName: 'Rachel Cubitt',
    branch: 'Blanket',
    authRepAndBroker: 'Enva Financial - Rachel Cubitt',
    salesTeam: 'Komal Chand',
    serviceTeam: '',
    insurer: '',
    transactionId: '47073',
    transactionType: 'CSH',
    transactionDate: '2025-11-05',
    particulars: 'EFT',
    dateReceivedFromInsurer: '',
    clientBalance: 143.17,
    balance: -42.27,
    isAllocated: false,
    status: 'unallocated',
  },
  {
    id: 'TXN-010',
    clientId: 'client-1',
    clientName: 'John Smith',
    branch: 'Blanket',
    authRepAndBroker: 'John Adviser',
    salesTeam: 'John Adviser',
    serviceTeam: 'John Adviser',
    insurer: 'Ando',
    transactionId: '001234',
    transactionType: 'INV',
    transactionDate: '2024-10-01',
    particulars: 'House Insurance Policy:PER-P0153674',
    dateReceivedFromInsurer: '2024-10-02',
    clientBalance: -250.00,
    balance: -250.00,
    policyId: 'PER-P0153674',
    isAllocated: true,
    status: 'allocated',
  },
  {
    id: 'TXN-011',
    clientId: 'client-1',
    clientName: 'John Smith',
    branch: 'Blanket',
    authRepAndBroker: 'John Adviser',
    salesTeam: 'John Adviser',
    serviceTeam: 'John Adviser',
    insurer: '',
    transactionId: '001235',
    transactionType: 'CSH',
    transactionDate: '2024-10-10',
    particulars: 'Direct Debit Payment',
    dateReceivedFromInsurer: '',
    clientBalance: -100.00,
    balance: -100.00,
    isAllocated: true,
    status: 'allocated',
  },
];

export const mockSchedules: Schedule[] = [
  {
    id: 'SCH-333',
    policyId: 'PER-P0153674',
    policyProduct: 'House',
    clientId: 'client-1',
    clientName: 'John Smith',
    frequency: 'monthly',
    instalments: 12,
    startDate: '2024-09-01',
    endDate: '2025-08-01',
    nextDebit: '2024-11-01',
    collected: 400.00,
    total: 1450.00,
    method: 'direct-debit',
    mandateStatus: 'active',
    status: 'active',
    arrears: 100.00,
    assignedAdviser: 'adv-001',
  },
  {
    id: 'SCH-334',
    policyId: 'PER-P0154821',
    policyProduct: 'Vehicle',
    clientId: 'client-3',
    clientName: 'Mike Brown',
    frequency: 'monthly',
    instalments: 4,
    startDate: '2024-11-01',
    endDate: '2025-02-01',
    nextDebit: '2024-11-15',
    collected: 0,
    total: 1120.00,
    method: 'direct-debit',
    mandateStatus: 'active',
    status: 'active',
    arrears: 0,
    assignedAdviser: 'adv-002',
  },
  {
    id: 'SCH-335',
    policyId: 'PER-P0156102',
    policyProduct: 'House',
    clientId: 'client-5',
    clientName: 'Lisa Chen',
    frequency: 'fortnightly',
    instalments: 26,
    startDate: '2024-10-01',
    endDate: '2025-09-01',
    nextDebit: '2024-11-05',
    collected: 200.00,
    total: 2100.00,
    method: 'credit-card',
    mandateStatus: 'active',
    status: 'active',
    arrears: 325.00,
    assignedAdviser: 'adv-001',
  },
  {
    id: 'SCH-336',
    policyId: 'PER-P0152990',
    policyProduct: 'Commercial Combined',
    clientId: 'client-4',
    clientName: 'ABC Enterprises Ltd',
    frequency: 'monthly',
    instalments: 1,
    startDate: '2024-10-20',
    endDate: '2024-10-20',
    nextDebit: '2024-10-30',
    collected: 0,
    total: 2800.00,
    method: 'direct-debit',
    mandateStatus: 'active',
    status: 'failed',
    arrears: 2800.00,
    assignedAdviser: 'adv-002',
  },
  {
    id: 'SCH-337',
    policyId: 'PER-P0157821',
    policyProduct: 'Vehicle',
    clientId: 'client-rebecca',
    clientName: 'Ms Rebecca Whitmore',
    frequency: 'weekly',
    instalments: 52,
    startDate: '2024-10-28',
    endDate: '2025-10-28',
    nextDebit: '2024-11-04',
    collected: 0,
    total: 1250.00,
    method: 'credit-card',
    mandateStatus: 'active',
    status: 'active',
    arrears: 0,
    assignedAdviser: 'adv-001',
  },
];

export const mockActivities: Activity[] = [
  {
    id: 'act-1',
    type: 'quote-bound',
    description: 'Quote #231 for John Smith was bound',
    timestamp: '2024-10-20T14:30:00',
    clientName: 'John Smith',
    adviserId: 'adv-001',
  },
  {
    id: 'act-2',
    type: 'quote-created',
    description: 'New vehicle quote created for Sarah Johnson',
    timestamp: '2024-10-18T10:15:00',
    clientName: 'Sarah Johnson',
    adviserId: 'adv-001',
  },
  {
    id: 'act-3',
    type: 'referral-submitted',
    description: 'Quote #233 submitted for referral',
    timestamp: '2024-10-15T16:45:00',
    clientName: 'Mike Brown',
    adviserId: 'adv-002',
  },
  {
    id: 'act-4',
    type: 'quote-created',
    description: 'New contents quote created for Sarah Johnson',
    timestamp: '2024-10-20T11:20:00',
    clientName: 'Sarah Johnson',
    adviserId: 'adv-001',
  },
];

export const mockAssets: Asset[] = [
  // John Smith's assets
  {
    id: 'asset-h001',
    clientId: 'client-1',
    type: 'house',
    description: 'House: 45 Queen Street, Auckland',
    value: 650000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-15',
    updatedAt: '2024-10-20',
    data: {
      address: '45 Queen Street',
      suburb: 'Auckland',
      postcode: '1010',
      yearBuilt: '1985',
      constructionType: 'Brick',
      bedrooms: 3,
      bathrooms: 2,
      garageCarparks: 2,
      alarmInstalled: 'yes',
      sumInsured: 650000,
      excess: 500,
    },
  },
  {
    id: 'asset-c001',
    clientId: 'client-1',
    type: 'contents',
    description: 'Contents: 45 Queen Street, Auckland',
    value: 85000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-15',
    updatedAt: '2024-10-20',
    data: {
      sumInsured: 85000,
      excess: 300,
      coverType: 'specified-items',
      securityMeasures: 'alarm-deadlocks',
    },
  },
  {
    id: 'asset-v003',
    clientId: 'client-1',
    type: 'vehicle',
    description: 'Vehicle: 2020 Honda Civic (JKL456)',
    value: 28000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-15',
    updatedAt: '2024-10-20',
    data: {
      vehicleReg: 'JKL456',
      year: '2020',
      make: 'Honda',
      model: 'Civic',
      vehicleType: 'sedan',
      engineCC: 1500,
      currentValue: 28000,
      annualKm: 10000,
      primaryUse: 'private',
      financedLeased: 'no',
      coverType: 'comprehensive',
      excess: 400,
    },
  },
  {
    id: 'asset-h004',
    clientId: 'client-1',
    type: 'house',
    description: 'House: 12 Beach Road, Tauranga (Holiday Home)',
    value: 480000,
    insured: false,
    status: 'not-insured',
    createdAt: '2024-09-20',
    updatedAt: '2024-09-20',
    data: {
      address: '12 Beach Road',
      suburb: 'Tauranga',
      postcode: '3110',
      yearBuilt: '2000',
      constructionType: 'Weatherboard',
      bedrooms: 2,
      bathrooms: 1,
      garageCarparks: 1,
      alarmInstalled: 'no',
      sumInsured: 480000,
      excess: 500,
    },
  },
  // Sarah Johnson's assets
  {
    id: 'asset-v001',
    clientId: 'client-2',
    type: 'vehicle',
    description: 'Vehicle: 2018 Toyota Corolla (ABC123)',
    value: 22000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-18',
    updatedAt: '2024-10-22',
    data: {
      vehicleReg: 'ABC123',
      year: '2018',
      make: 'Toyota',
      model: 'Corolla',
      vehicleType: 'sedan',
      engineCC: 1800,
      currentValue: 22000,
      annualKm: 12000,
      primaryUse: 'private',
      financedLeased: 'no',
      coverType: 'comprehensive',
      excess: 400,
    },
  },
  {
    id: 'asset-h002',
    clientId: 'client-2',
    type: 'house',
    description: 'House: 28 Pine Avenue, Wellington',
    value: 520000,
    insured: false,
    status: 'not-insured',
    createdAt: '2024-09-10',
    updatedAt: '2024-09-10',
    data: {
      address: '28 Pine Avenue',
      suburb: 'Wellington',
      postcode: '6011',
      yearBuilt: '1995',
      constructionType: 'Weatherboard',
      bedrooms: 2,
      bathrooms: 1,
      garageCarparks: 1,
      alarmInstalled: 'no',
      sumInsured: 520000,
      excess: 500,
    },
  },
  // Mike Brown's assets
  {
    id: 'asset-h003',
    clientId: 'client-3',
    type: 'house',
    description: 'House: 89 High Street, Christchurch',
    value: 750000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-12',
    updatedAt: '2024-10-15',
    data: {
      address: '89 High Street',
      suburb: 'Christchurch',
      postcode: '8011',
      yearBuilt: '2005',
      constructionType: 'Brick',
      bedrooms: 4,
      bathrooms: 2,
      garageCarparks: 2,
      alarmInstalled: 'yes',
      sumInsured: 750000,
      excess: 750,
    },
  },
  {
    id: 'asset-c003',
    clientId: 'client-3',
    type: 'contents',
    description: 'Contents: 89 High Street, Christchurch',
    value: 85000,
    insured: true,
    status: 'insured',
    createdAt: '2024-10-12',
    updatedAt: '2024-10-15',
    data: {
      sumInsured: 85000,
      excess: 300,
      coverType: 'specified-items',
      securityMeasures: 'alarm-deadlocks',
    },
  },
  {
    id: 'asset-v002',
    clientId: 'client-3',
    type: 'vehicle',
    description: 'Vehicle: 2020 BMW 3 Series (XYZ789)',
    value: 55000,
    insured: false,
    status: 'not-insured',
    createdAt: '2024-08-20',
    updatedAt: '2024-08-20',
    data: {
      vehicleReg: 'XYZ789',
      year: '2020',
      make: 'BMW',
      model: '3 Series',
      vehicleType: 'sedan',
      engineCC: 2000,
      currentValue: 55000,
      annualKm: 15000,
      primaryUse: 'private',
      financedLeased: 'no',
      coverType: 'comprehensive',
      excess: 500,
    },
  },
];

// Commission Schedules
export const mockCommissionSchedules: CommissionSchedule[] = [
  {
    id: 'cs-001',
    scope: 'fap',
    fapId: 'fap-001',
    newBusinessPercent: 20,
    renewalPercent: 12.5,
    effectiveFrom: '2024-01-01',
    priority: 100,
    createdAt: '2024-01-01',
    updatedAt: '2024-01-01',
  },
  {
    id: 'cs-002',
    scope: 'fap',
    fapId: 'fap-002',
    newBusinessPercent: 18,
    renewalPercent: 10,
    effectiveFrom: '2024-01-01',
    priority: 100,
    createdAt: '2024-01-01',
    updatedAt: '2024-01-01',
  },
  {
    id: 'cs-003',
    scope: 'adviser',
    adviserId: 'adv-003',
    fapId: 'fap-001',
    newBusinessPercent: 25,
    renewalPercent: 15,
    effectiveFrom: '2024-06-01',
    priority: 50,
    createdAt: '2024-06-01',
    updatedAt: '2024-06-01',
  },
  {
    id: 'cs-004',
    scope: 'insurer',
    fapId: 'fap-001',
    insurer: 'Ando',
    newBusinessPercent: 22,
    renewalPercent: 14,
    effectiveFrom: '2024-01-01',
    priority: 75,
    createdAt: '2024-01-01',
    updatedAt: '2024-01-01',
  },
  {
    id: 'cs-005',
    scope: 'fap',
    fapId: 'fap-004',
    newBusinessPercent: 22,
    renewalPercent: 13,
    effectiveFrom: '2024-01-01',
    priority: 100,
    createdAt: '2024-01-01',
    updatedAt: '2024-01-01',
  },
  {
    id: 'cs-006',
    scope: 'fap',
    fapId: 'fap-005',
    newBusinessPercent: 19,
    renewalPercent: 11,
    effectiveFrom: '2024-01-01',
    priority: 100,
    createdAt: '2024-01-01',
    updatedAt: '2024-01-01',
  },
];

// System Users
export const mockSystemUsers: SystemUser[] = [
  {
    id: 'sysuser-001',
    firstName: 'Sarah',
    lastName: 'Admin',
    email: 'sarah@tapgroup.co.nz',
    phone: '09 123 4567',
    department: 'Administration',
    roles: ['SUPER_ADMIN'],
    mfaEnabled: true,
    status: 'active',
    lastLogin: '2025-11-05T09:22:00',
    ipHistory: [
      {
        ip: '203.123.45.67',
        location: 'Auckland, NZ',
        loginCount: 87,
        lastLogin: '2025-11-05T09:22:00',
      },
    ],
    activityLog: [
      {
        id: 'act-001',
        date: '2025-11-05',
        action: 'Edited Adviser',
        entity: 'Sarah Miller',
        reference: '#A-0042',
      },
      {
        id: 'act-002',
        date: '2025-11-04',
        action: 'Approved Quote',
        entity: 'Quote',
        reference: 'PER-00935280',
      },
      {
        id: 'act-003',
        date: '2025-11-04',
        action: 'Created FAP',
        entity: 'Haven Financial',
        reference: '#FAP-003',
      },
      {
        id: 'act-004',
        date: '2025-11-03',
        action: 'Updated Commission',
        entity: 'Premier Advisers',
        reference: '#CS-012',
      },
      {
        id: 'act-005',
        date: '2025-11-03',
        action: 'Bound Policy',
        entity: 'Policy',
        reference: 'POL-12345',
      },
    ],
    linkedEntities: [],
    notes: 'Senior admin with full system access',
    auditTrail: [
      {
        id: 'audit-001',
        date: '2025-11-01',
        action: 'Role Added',
        performedBy: 'System Admin',
        details: 'Added "broker" role',
      },
      {
        id: 'audit-002',
        date: '2025-10-12',
        action: 'Email Changed',
        performedBy: 'System Admin',
        details: 'Changed email from sarah@insurance.com to sarah@tapgroup.co.nz',
      },
    ],
    createdAt: '2024-01-10',
    updatedAt: '2025-11-01',
  },
  {
    id: 'sysuser-002',
    firstName: 'Emma',
    lastName: 'Johnson',
    email: 'emma@tapgroup.co.nz',
    phone: '09 555 1234',
    department: 'Operations',
    fapId: 'fap-001',
    fapName: 'Haven Financial',
    linkedAdviserId: 'adv-002',
    linkedAdviserName: 'Sarah Miller',
    roles: ['BUSINESS_ADMIN'],
    mfaEnabled: true,
    status: 'active',
    lastLogin: '2025-11-04T11:12:00',
    ipHistory: [
      {
        ip: '203.123.45.68',
        location: 'Auckland, NZ',
        loginCount: 45,
        lastLogin: '2025-11-04T11:12:00',
      },
    ],
    activityLog: [
      {
        id: 'act-006',
        date: '2025-11-04',
        action: 'Processed Payment',
        entity: 'Invoice',
        reference: 'INV-54321',
      },
      {
        id: 'act-007',
        date: '2025-11-03',
        action: 'Created Quote',
        entity: 'Quote',
        reference: 'PER-00935281',
      },
      {
        id: 'act-008',
        date: '2025-11-03',
        action: 'Updated Client',
        entity: 'John Smith',
        reference: '#C-0123',
      },
      {
        id: 'act-009',
        date: '2025-11-02',
        action: 'Generated Report',
        entity: 'Commission Report',
        reference: 'RPT-Nov-2025',
      },
      {
        id: 'act-010',
        date: '2025-11-01',
        action: 'Uploaded Document',
        entity: 'Policy Document',
        reference: 'POL-12346',
      },
    ],
    linkedEntities: [
      {
        type: 'adviser',
        id: 'adv-002',
        name: 'Sarah Miller',
        role: 'Quoter',
      },
      {
        type: 'fap',
        id: 'fap-001',
        name: 'Haven Financial',
        role: 'FAP Admin',
      },
    ],
    notes: 'Operations specialist - handles daily quote processing',
    auditTrail: [
      {
        id: 'audit-003',
        date: '2025-10-15',
        action: 'Linked to FAP',
        performedBy: 'Sarah Admin',
        details: 'Linked to Haven Financial as FAP Admin',
      },
      {
        id: 'audit-004',
        date: '2025-10-01',
        action: 'MFA Enabled',
        performedBy: 'Emma Johnson',
        details: 'Enabled multi-factor authentication',
      },
    ],
    createdAt: '2024-05-10',
    updatedAt: '2025-10-15',
  },
  {
    id: 'sysuser-003',
    firstName: 'Michael',
    lastName: 'Roberts',
    email: 'michael@tapgroup.co.nz',
    phone: '09 666 7890',
    department: 'Finance',
    roles: ['FINANCE_ADMIN'],
    mfaEnabled: false,
    status: 'active',
    lastLogin: '2025-11-03T14:30:00',
    ipHistory: [
      {
        ip: '203.123.45.69',
        location: 'Wellington, NZ',
        loginCount: 23,
        lastLogin: '2025-11-03T14:30:00',
      },
    ],
    activityLog: [
      {
        id: 'act-011',
        date: '2025-11-03',
        action: 'Viewed Invoice',
        entity: 'Invoice',
        reference: 'INV-54320',
      },
      {
        id: 'act-012',
        date: '2025-11-02',
        action: 'Generated Report',
        entity: 'Financial Report',
        reference: 'RPT-FIN-Oct-2025',
      },
      {
        id: 'act-013',
        date: '2025-11-01',
        action: 'Reconciled Payment',
        entity: 'Payment',
        reference: 'PAY-98765',
      },
    ],
    linkedEntities: [],
    notes: 'Finance team member - view-only access to quotes',
    auditTrail: [
      {
        id: 'audit-005',
        date: '2025-09-01',
        action: 'Role Added',
        performedBy: 'Sarah Admin',
        details: 'Added "finance" role',
      },
    ],
    createdAt: '2024-08-15',
    updatedAt: '2025-09-01',
  },
];
